export default "__VITE_ASSET__Du4YH_zi__"